import { getData, postData } from "../axiosConfig"

export const admimLogin = async (body) => {
    return await postData('/admin/login', body)
}

export const admimMe = async (id) => {
    return await getData(`/admin/me/${id}`)
}

export const userChart = async (start_date = "", end_date = "") => {

    if (start_date && end_date) {

        return await getData(`/admin/user-chart?start_date=${start_date}&end_date=${end_date}`)
    }
    else {
        return await getData(`/admin/user-chart`)
    }

}

// /admin/user-chart?start_date=2025-06-12&end_date=2025-06-14